module.exports = __webpack_public_path__ + "img/LINE_APP.414687b5.png";